class ConstraintData {
  constructor(name, order, skinRequired) {
    this.name = name;
    this.order = order;
    this.skinRequired = skinRequired;
  }
}

export { ConstraintData };
//# sourceMappingURL=Constraint.mjs.map
